// Lib
import gql from 'graphql-tag';

// Types
import {
  ORGANIZATION_MEMBER,
  ORGANIZATION_PROFILE,
  ORGANIZATION_SHIPPING_DETAILS,
} from '../types';

// NB: deliberately omits `members` — the just-created org context can't read
// the members collection yet, so requesting it makes the field throw
// `Forbidden` (path createOrganization.members) even though the org is created.
// Callers only need the scalars + token + profile here; members load later.
export const createOrganizationMutation = gql`
  mutation CreateOrganization($input: CreateOrganizationInput) {
    createOrganization(input: $input) {
      _id
      createdAt
      updatedAt
      accountId
      type
      isActive
      isPublic
      membersCount
      token
      profile {
        ${ORGANIZATION_PROFILE}
      }
    }
  }
`;

export const updateOrganizationProfileMutation = gql`
  mutation UpdateOrganizationProfile($input: UpdateOrganizationProfileInput) {
    updateOrganizationProfile(input: $input) {
      ${ORGANIZATION_PROFILE}
    }
  }
`;

export const inviteMemberMutation = gql`
  mutation InviteMember($input: InviteMemberInput!) {
    inviteMember(input: $input) {
      ${ORGANIZATION_MEMBER}
    }
  }
`;

export const updateMemberMutation = gql`
  mutation UpdateMember($input: UpdateMemberInput!) {
    updateMember(input: $input) {
      ${ORGANIZATION_MEMBER}
    }
  }
`;

export const organizationShippingDetailsCreateMutation = gql`
  mutation OrganizationShippingDetailsCreate($input: CreateOrganizationShippingDetailsInput!) {
    organizationShippingDetailsCreate(input: $input) {
      ${ORGANIZATION_SHIPPING_DETAILS}
    }
  }
`;

export const cancelMemberInvitation = gql`
  mutation CancelMemberInvitation(
    $input: CancelOrganizationMemberInvitationInput!
  ) {
    cancelMemberInvitation(input: $input)
  }
`;

export const deleteMember = gql`
  mutation DeleteMember($input: DeleteOrganizationMemberInput!) {
    deleteMember(input: $input)
  }
`;

export const acceptOrganizationInvitationMutation = gql`
  mutation AcceptOrganizationInvitation($invitationId: String!) {
    acceptOrganizationInvitation(invitationId: $invitationId) {
      _id
      accountId
      type
      isActive
      isPublic
      membersCount
      createdAt
      updatedAt
      token
      profile {
        ${ORGANIZATION_PROFILE}
      }
    }
  }
`;

export const declineOrganizationInvitationMutation = gql`
  mutation DeclineOrganizationInvitation($invitationId: String!) {
    declineOrganizationInvitation(invitationId: $invitationId)
  }
`;

// Compatibility for invitation emails sent before account-bound invite links
// were introduced. New existing-user invitations never contain this secret.
export const acceptLegacyOrganizationInvitationMutation = gql`
  mutation AcceptLegacyOrganizationInvitation($input: AcceptInvitationInput!) {
    acceptInvitation(input: $input)
  }
`;
